export const ID_SUPERUSER = 1;
